import React, { Component } from "react";
import { injectIntl } from "react-intl";
import {
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu, Button
} from "reactstrap";

import { NavLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from 'axios';

import {
  setContainerClassnames,
  clickOnMobileMenu,
  logoutUser,
  loginAsSubscriber,
  changeLocale
} from "../../redux/actions";

import {
  menuHiddenBreakpoint,
  searchPath, BASE_URL
} from "../../constants/defaultValues";

import { MobileMenuIcon, MenuIcon } from "../../components/svg";
import TopnavEasyAccess from "./Topnav.EasyAccess";
import TopnavNotifications from "./Topnav.Notifications";
import ModalHelpContainer from "./ModalHelpContainer";

import SimpleCrypto from "simple-crypto-js";

import {REST_API_END_POINT, dataEncryptKey} from "../../constants/defaultValues";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import { setCookie } from "../../helpers/Utils";

var dataCrypto = new SimpleCrypto(dataEncryptKey);

class TopNav extends Component {
  constructor(props) {
    super(props);

	this.LoginBackToAdmin = this.LoginBackToAdmin.bind(this);
    this.state = {
      isInFullScreen: false,
      searchKeyword: "",
	  modalHelp: false,
	  facility_data:null,
	  theme: localStorage.getItem('theme') || 'light',
	  themeColor: localStorage.getItem('themeColor') || 'light.purple',
    };
  }
  
	componentDidMount() {
		window.addEventListener('storage', this.handleThemeSync);
		window.addEventListener('storage', this.handleFacilitySync);
		let savedTheme = localStorage.getItem('theme') || 'light';
		let savedThemeColor = localStorage.getItem('themeColor') || 'light.purple';

		const facility_id_encrypted = localStorage.getItem('facility_id');
		if (facility_id_encrypted) {
			const facility_id = dataCrypto.decrypt(facility_id_encrypted);
			if (facility_id == 13 || facility_id == 14) {
				savedTheme = 'dark';
				savedThemeColor = 'light.orange';
				localStorage.setItem('theme', savedTheme);
				localStorage.setItem('themeColor', savedThemeColor);
			}
		}

		document.body.classList.remove('light', 'dark');
		document.body.classList.add(savedTheme);
		this.setState({ theme: savedTheme, themeColor: savedThemeColor });

		var form_data = new FormData();
		form_data.append('user_id',localStorage.getItem('user_id'));
		if(localStorage.getItem('user_id')!=null){
			axios.post(REST_API_END_POINT+'register/get-user-data',form_data).then((res)=>{ 
				if(res.data.id){
					var user_session=JSON.parse(localStorage.getItem('user_data'));
					user_session.first_name=res.data.first_name;
					user_session.last_name=res.data.last_name;
					user_session.profile_pic=res.data.profile_pic;
					localStorage.setItem('user_data', JSON.stringify(user_session));
				}
			}).catch(e => console.log("Addition failed , Error ", e));
		}
		
		var facility_id = localStorage.getItem('facility_id');
		if(facility_id!=null){
			facility_id =  dataCrypto.decrypt(facility_id);
			var formData = new FormData();
			formData.append('facility_id',facility_id);
			axios.post(REST_API_END_POINT+'website/configurations',formData).then((res)=>{
				this.setState({ facility_data: res.data.configurations, blocking:false });
			}).catch(e =>{ 
				console.log("Addition failed, Error ", e) 
				this.setState({ blocking:false });
			});
		}
		
	}

	handleFacilitySync = (event) => {
		if (event.key === 'facility-update-timestamp') {
			const isPos = window.location.pathname.startsWith("/app/point-of-sale/pos");
			if (isPos) {
				window.location.href = "/app/point-of-sale/customer-lookup";
			} else {
				window.location.reload();
			}
		}
	};

	handleThemeSync = (event) => {
		if (event.key === 'theme-update-timestamp') {
			const newTheme = localStorage.getItem('theme') || 'light';
			const newThemeColor = localStorage.getItem('themeColor') || 'light.purple';
		
			this.setState({ theme: newTheme, themeColor: newThemeColor }, () => {
				window.location.reload();
			});
			document.body.classList.remove('light', 'dark');
			document.body.classList.add(newTheme);
		}
	};

	componentWillUnmount() {
		window.removeEventListener('storage', this.handleThemeSync);
		window.removeEventListener('storage', this.handleFacilitySync);
	}
	
	toggleModalHelp = () => {
		this.setState({
		  modalHelp: !this.state.modalHelp
		});
	};

	handleChangeLocale = locale => {
		this.props.changeLocale(locale);
	};
	
	isInFullScreen = () => {
		return (
		  (document.fullscreenElement && document.fullscreenElement !== null) ||
		  (document.webkitFullscreenElement &&
			document.webkitFullscreenElement !== null) ||
		  (document.mozFullScreenElement &&
			document.mozFullScreenElement !== null) ||
		  (document.msFullscreenElement && document.msFullscreenElement !== null)
		);
	};
	
	handleSearchIconClick = e => {
		if (window.innerWidth < menuHiddenBreakpoint) {
		  let elem = e.target;
		  if (!e.target.classList.contains("search")) {
			if (e.target.parentElement.classList.contains("search")) {
			  elem = e.target.parentElement;
			} else if (
			  e.target.parentElement.parentElement.classList.contains("search")
			) {
			  elem = e.target.parentElement.parentElement;
			}
		  }

		  if (elem.classList.contains("mobile-view")) {
			this.search();
			elem.classList.remove("mobile-view");
			this.removeEventsSearch();
		  } else {
			elem.classList.add("mobile-view");
			this.addEventsSearch();
		  }
		} else {
		  this.search();
		}
	};
	
	addEventsSearch = () => {
		document.addEventListener("click", this.handleDocumentClickSearch, true);
	};
	
	removeEventsSearch = () => {
		document.removeEventListener("click", this.handleDocumentClickSearch, true);
	};

	handleDocumentClickSearch = e => {
		let isSearchClick = false;
		if (
		  e.target &&
		  e.target.classList &&
		  (e.target.classList.contains("navbar") ||
			e.target.classList.contains("simple-icon-magnifier"))
		) {
		  isSearchClick = true;
		  if (e.target.classList.contains("simple-icon-magnifier")) {
			this.search();
		  }
		} else if (
		  e.target.parentElement &&
		  e.target.parentElement.classList &&
		  e.target.parentElement.classList.contains("search")
		) {
		  isSearchClick = true;
		}

		if (!isSearchClick) {
		  const input = document.querySelector(".mobile-view");
		  if (input && input.classList) input.classList.remove("mobile-view");
		  this.removeEventsSearch();
		  this.setState({
			searchKeyword: ""
		  });
		}
	};
	
	handleSearchInputChange = e => {
		this.setState({
		  searchKeyword: e.target.value
		});
	};
	
	handleSearchInputKeyPress = e => {
		if (e.key === "Enter") {
		  this.search();
		}
	};

	search = () => {
		this.props.history.push(searchPath + "/" + this.state.searchKeyword);
		this.setState({
		  searchKeyword: ""
		});
	};

	toggleFullScreen = () => {
		const isInFullScreen = this.isInFullScreen();

		var docElm = document.documentElement;
		if (!isInFullScreen) {
		  if (docElm.requestFullscreen) {
			docElm.requestFullscreen();
		  } else if (docElm.mozRequestFullScreen) {
			docElm.mozRequestFullScreen();
		  } else if (docElm.webkitRequestFullScreen) {
			docElm.webkitRequestFullScreen();
		  } else if (docElm.msRequestFullscreen) {
			docElm.msRequestFullscreen();
		  }
		} else {
		  if (document.exitFullscreen) {
			document.exitFullscreen();
		  } else if (document.webkitExitFullscreen) {
			document.webkitExitFullscreen();
		  } else if (document.mozCancelFullScreen) {
			document.mozCancelFullScreen();
		  } else if (document.msExitFullscreen) {
			document.msExitFullscreen();
		  }
		}
		this.setState({
		  isInFullScreen: !isInFullScreen
		});
	};

	handleLogout = () => {

		this.props.logoutUser(this.props.history);
		localStorage.clear()
	};

	menuButtonClick = (e, menuClickCount, containerClassnames) => {
		e.preventDefault();

		setTimeout(() => {
		  var event = document.createEvent("HTMLEvents");
		  event.initEvent("resize", false, false);
		  window.dispatchEvent(event);
		}, 350);
		this.props.setContainerClassnames(
		  ++menuClickCount,
		  containerClassnames,
		  this.props.selectedMenuHasSubItems
		);
	};
	
	mobileMenuButtonClick = (e, containerClassnames) => {
		e.preventDefault();
		this.props.clickOnMobileMenu(containerClassnames);
	};
	
	LoginBackToAdmin() {
		const user_id = localStorage.getItem('user_id');
		this.props.loginAsSubscriber({user_id:1,from_id:user_id}, this.props.history);
	}

	onClickHandler = (newTheme) => {
		var old_facility_id = localStorage.getItem('facility_id');
		old_facility_id =  dataCrypto.decrypt(old_facility_id);
		console.log('onClickHandler--old_facility_id', old_facility_id)

		// Switch between Mahatta and Test Mahatta, Qasmia and Test Qasmia
		let facility_id;
		if (old_facility_id == 7 && newTheme == 'dark') {
			facility_id = 13;  // Mahatta → Test Mahatta
		}else if (old_facility_id == 13 && newTheme == 'light') {
			facility_id = 7;   // Test Mahatta → Mahatta
		}else if (old_facility_id == 10 && newTheme == 'dark') {
			facility_id = 14;  // Qasmia → Test Qasmia
		}else if (old_facility_id == 14 && newTheme == 'light') {
			facility_id = 10;  // Test Qasmia → Qasmia
		}else{
			facility_id = old_facility_id; // Everything else unchanged
		}
		console.log('onClickHandler--facility_id', facility_id)
		localStorage.setItem('facility_id', dataCrypto.encrypt(facility_id));
		// id: "14", name: "Test Qasmia"
		// id: "13", name: "Test Mahatta"
		// id: "12", name: "Test Facility 2"
		// id: "11", name: "Test Facility"
		// id: "10", name: "Al Ikhtayar  Al Qasmia"
		// id: "7", name: "Al Ikhtayar Al Mahatta"

		// Trigger change event manually
		var form_data = new FormData();
		form_data.append("facility_id",facility_id);
		var user_id = localStorage.getItem('user_id');
		form_data.append('user_id',user_id)
		axios.post(REST_API_END_POINT+'register/get-facility-data',form_data).then((data)=>{					
			if(data.data.status==1){
				localStorage.setItem('facility_id', dataCrypto.encrypt(facility_id));
				localStorage.setItem('facility_data', dataCrypto.encrypt(data.data.facility_data));
				setCookie('pos_customer_id',null);
				setCookie('cart',null);
				setCookie('currency_code',null);
				setCookie('bogo_code',null);
				setCookie('payment_data',null);
				setCookie('change_data',null);
				localStorage.removeItem('shopCartCoupon');
				localStorage.removeItem('shopCartCouponCode');
				localStorage.removeItem('shopCartItems');

				// Trigger change event manually
				localStorage.setItem('facility-update-timestamp', Date.now());
				const isPos = window.location.pathname.startsWith("/app/point-of-sale/pos");
				if (isPos) {
					window.location.href = "/app/point-of-sale/customer-lookup";
				} else {
					window.location.reload();
				}
			}					
		}).catch(e => console.log("Addition failed , Error ", e));
	}

	toggleTheme = () => {
		const newTheme = this.state.theme === 'light' ? 'dark' : 'light';
		const newThemeColor = this.state.theme === 'light' ? 'light.orange' : 'light.purple';
		localStorage.setItem('theme', newTheme);
		localStorage.setItem('themeColor', newThemeColor);
		// localStorage.setItem('theme-update-timestamp', Date.now());
		
		this.setState({ theme: newTheme, themeColor: newThemeColor })
		this.onClickHandler(newTheme);
		// this.setState({ theme: newTheme, themeColor: newThemeColor }, () => {
		// 	window.location.reload();
		// });
	  
		document.body.classList.remove('light', 'dark');
		document.body.classList.add(newTheme);
	};

  render() {
    const { containerClassnames, menuClickCount } = this.props;
    //const { messages } = this.props.intl;
	const user_id = localStorage.getItem('user_id');
	const user_data = JSON.parse(localStorage.getItem('user_data'));
	const login_admin = localStorage.getItem('login_admin');
	var is_admin=false;	
	if(login_admin!=null && typeof login_admin!='undefined' && user_id!=1){
		is_admin=true;
	}
	
	let facility_data = this.state.facility_data;
	
	let default_logo = <a className="navbar-logo" href="/">
			  <span className="logo d-none d-xs-block" />
			  <span className="logo-mobile d-block d-xs-none" />
			</a>;
			
	if(facility_data!=null){
		if(facility_data.facility_logo!=null && facility_data.facility_mobile_logo!=null){
			default_logo=<a className="navbar-logo navbar-logo-img" href="/">
			  <img src={BASE_URL+'pages/'+facility_data.facility_logo} className="img-responsive d-none d-sm-block"  />
			  <img src={BASE_URL+'pages/'+facility_data.facility_mobile_logo} className="logo-mobile-img img-responsive d-block d-sm-none"  />
			</a>
		}else if(facility_data.facility_logo!=null){
			default_logo=<a className="navbar-logo navbar-logo-img" href="/">
				<img src={BASE_URL+'pages/'+facility_data.facility_logo} className="img-responsive d-none d-sm-block"  />
				<span className="logo-mobile d-block d-sm-none" />
			</a>
		}else if(facility_data.facility_mobile_logo!=null){
			default_logo=<a className="navbar-logo navbar-logo-img" href="/">
				<span className="logo d-none d-sm-block" />
				<img src={BASE_URL+'pages/'+facility_data.facility_mobile_logo} className="logo-mobile-img img-responsive d-block d-sm-none"  />
			</a>
		}
	}
	
    return (<div>
		{is_admin ? <div className="logged-in-as-user-bar fixed-top">Logged in as <strong>{user_data.first_name}{" "}{user_data.last_name}</strong> <Button color="info" size="xs" onClick={this.LoginBackToAdmin}>Switch back to admin</Button></div>:""}	
		<nav className={"navbar fixed-top "+(is_admin ? " logged-in-as-user-bar-exist":"")}>
			
			<NavLink
			  to="#"
			  className="menu-button d-none d-md-block"
			  onClick={e =>
				this.menuButtonClick(e, menuClickCount, containerClassnames)
			  }
			>
				<div style={{ width: '40px', display: 'inline-block',
					backgroundColor: localStorage.getItem('theme') === 'dark' ? '#ffffff' : 'transparent',
					padding: '5px',
					borderRadius: '4px'
				 }}>
					<MenuIcon />
			  	</div>
			</NavLink>
			<NavLink
			  to="#"
			  className="menu-button-mobile d-xs-block d-sm-block d-md-none"
			  onClick={e => this.mobileMenuButtonClick(e, containerClassnames)}
			>
				<div style={{ width: '40px', display: 'inline-block',
					backgroundColor: localStorage.getItem('theme') === 'dark' ? '#ffffff' : 'transparent',
					padding: '5px',
					borderRadius: '4px'
				 }}>
					<MobileMenuIcon />
			  	</div>
			</NavLink>

			{default_logo}
			<div className="mt-2" style={{marginLeft: 'auto'}}>
				{localStorage.getItem('theme') == 'dark' ?
					<h3 className="d-inline-block mb-0 text-secondary" >{facility_data!=null ? facility_data.facility_name:""}</h3>
				:
					<h3 className="d-inline-block mb-0 text-primary" >{facility_data!=null ? facility_data.facility_name:""}</h3>
  				}
			</div>
			<div className="ml-auto">				
			  <div className="header-icons d-inline-block align-middle">				
				{user_data.user_type!="2" ? <TopnavEasyAccess />:""}
				{/*<TopnavNotifications />*/}
				
				<ModalHelpContainer
					modalOpen={this.state.modalHelp}
					toggleModal={this.toggleModalHelp}
				  />
				{localStorage.getItem('theme') == 'dark' ?
					<button
						className="header-icon btn btn-empty d-inline-block"
						type="button"
						id="fullScreenButton"
						onClick={this.toggleFullScreen}
					>
						{this.state.isInFullScreen ? (
							<i className="simple-icon-size-actual d-block text-secondary" />
						) : (
							<i className="simple-icon-size-fullscreen d-block text-secondary" />
						)}
					</button>
				:
					<button
						className="header-icon btn btn-empty d-inline-block"
						type="button"
						id="fullScreenButton"
						onClick={this.toggleFullScreen}
					>
						{this.state.isInFullScreen ? (
							<i className="simple-icon-size-actual d-block" />
						) : (
							<i className="simple-icon-size-fullscreen d-block" />
						)}
					</button>
  				}
			  </div>
			  <div className="user d-inline-block">
				<UncontrolledDropdown className="dropdown-menu-right">
				  <DropdownToggle className="p-0" color="empty">
					<span className="name mr-1" id="user_profile_name">{user_data!=null ? user_data.first_name+' '+user_data.last_name:""}</span>
					<span>
						<img id="user_profile_img" alt="Profile" src={user_data!=null ? BASE_URL+'users/'+user_data.profile_pic:"/assets/img/profile-pic-l-2.jpg"} />
					</span>
				  </DropdownToggle>
				  <DropdownMenu className="mt-3" right>
					<DropdownItem className="p-0">
						<NavLink to="/app/profile" className="d-block px-4 py-2">
							Profile
						</NavLink>	
					</DropdownItem>                
					<DropdownItem divider />
					<DropdownItem className="d-flex align-items-center">
					<span style={{marginRight: 12}}>
						Dark Mode
						{/* {this.state.theme === 'light' ? 'Light' : 'Dark'} Mode */}
					</span>
					<Switch
						className="custom-switch custom-switch-primary im-inline-block"
						checked={this.state.theme == 'dark'}
						onClick={ this.toggleTheme }
					/>
					</DropdownItem>
					<DropdownItem divider />
					<DropdownItem onClick={() => this.handleLogout()}>
					  Sign out
					</DropdownItem>
				  </DropdownMenu>
				</UncontrolledDropdown>
			  </div>
			</div>
		</nav>
    </div>);
  }
}

const mapStateToProps = ({ menu, settings }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  const { locale } = settings;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
    locale
  };
};
export default injectIntl(
  withRouter(connect(
    mapStateToProps,
    { setContainerClassnames, clickOnMobileMenu, logoutUser, loginAsSubscriber, changeLocale }
  )(TopNav))
);
